import * as angular from "angular";
import {IController} from "angular";
import {CommonsDialogService} from "../../services/commons-dialog.service";

export class BringozTimePickerComponent implements IController {
  isDisabled: any;
  range: any;
  isShowTimeWindowTab: boolean;

  onTimeSelect: Function;

  constructor(private $log, private commonsDialogService: CommonsDialogService) {
  }

  openDialog(event) {
    this.commonsDialogService.timeSelection(this.range, this.range.dateStart, this.isShowTimeWindowTab, event)
      .then((range) => {
        this.onTimeSelect({range: range});
      })
      .catch((error) => {
        if (error) {
          this.$log.info(error.message);
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimePicker', {
    bindings: {
      isDisabled: '<',
      range: '<',
      isShowTimeWindowTab: '<',
      onTimeSelect: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-time-picker/bringoz-time-picker.html',

    controller: BringozTimePickerComponent
  });
